import React from 'react';
import trackEvent from '../../utils/trackEvent';

const _addToCart = function(props) {
  const { recommendedVariant, _optionChanged, closeFitFinder, handle, vendor } = props;
  if (Object.keys(recommendedVariant).length > 0) {
    recommendedVariant.options.forEach((option, index) => {
      _optionChanged(`option${index + 1}`, option)
    })
  }

  closeFitFinder();

  if (recommendedVariant.available) {
    trackEvent('Added To Cart', { vendor: vendor, handle: handle, sku: recommendedVariant.sku });
    const fitFinderAddEvent = new CustomEvent('fitFinder:add', { detail: { fitFinder: true } });
    setTimeout(() => { window.dispatchEvent(fitFinderAddEvent) }, 300);
  } else {
    const fitFinderAddEvent = new CustomEvent('fitFinder:waitlist', { detail: { fitFinder: true } });
    window.dispatchEvent(fitFinderAddEvent);
  }
}

const AddToCartButton = function(props) {
  const { recommendedVariant, product, _optionChanged, closeFitFinder, recommendedSize } = props;
  if (recommendedVariant && (recommendedVariant.available || product.tags.includes('BIS'))) {
    return (
      <button className="form-footer-button action-button" type="button" onClick={() => _addToCart({ recommendedVariant, _optionChanged, closeFitFinder, handle: product.handle, vendor: product.vendor })}>
        {recommendedVariant.available ? 'Add to Cart' : recommendedSize ? 'Join Waitlist' : 'Contact Us'}
      </button>
    )
  }
  return (null);
}

export default AddToCartButton;